<template>
  <connect-wallet v-if="showConnectWallet" />
  <mint v-if="showMint" :collection="collection" :mint="allowedPurchase" />
  <button v-if="showNotOnList" class="buy-now__shared highlighted">NOT ON LIST</button>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Mint from './Mint.vue'
import ConnectWallet from './ConnectWallet.vue'


export default {
  components: {
    Mint,
    ConnectWallet
  },
  props: ['collection'],
  computed: {
    ...mapState({
      showConnectWallet: function(state) {
        return !state.auth.account.isConnected
      },
      showMint: function(state) {
        return state.auth.account.isConnected && state.auth.proof.length > 0
      },
      showNotOnList: function(state) {
        return state.auth.account.isConnected && state.auth.proof.length === 0 
      },
    })
  },
  methods:{
     ...mapActions('drops', ['allowedPurchase'])
  }
}
</script>

<style scoped lang="scss">
p {
  @include on-desktop() {
    font-size: 1.25rem;
  }
}

.collection-pre-sale {
  // remove up and down arrows in input field for inputting number
  input[type='number'],
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -moz-appearance: textfield;
    -webkit-appearance: none;
    margin: 0;
    text-align: center;
  }
}
</style>
